import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { UnionServiceDelegation } from "../../Model/UnionServiceDelegation/UnionServiceDelegation";

export async function createUnionDelegationService(data) {
    let response = await getAPIResponse("/v1/union-service-delegation", data, "POST");
    if (response === null) {
        return null;
    }
    return UnionServiceDelegation.createFromResponseData(response);
}